<template>
  <div>
    <div class="separator-big"></div>
    <div class="title">Support</div>
    <div class="separator-small"></div>

    <div class="container">
      <span>Last Update: 02.10.2025</span>
    </div>

    <div class="container">
      <div class="separator-big"></div>
      <div class="sub-title">Need Help?</div>
      <div class="separator-small"></div>

      <div class="content">
        <p>
          This page provides support information for our apps and games. If you have questions, encounter a problem, or need help with a
          subscription or in-app purchase, you can contact us using the information below.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">How to Contact Support</p>
        <div class="separator-xs"></div>
        <p>
          The easiest way to reach us is by email:
        </p>
        <p>
          <b>Email:</b> <a href="mailto:info@arcade-space.com">info@arcade-space.com</a>
        </p>
        <p>
          When you contact us, please include:
        </p>
        <ul>
          <li>The name of the app or game you are using</li>
          <li>Your device model and iOS/iPadOS version</li>
          <li>A short description of the issue</li>
          <li>Screenshots or screen recordings, if possible</li>
        </ul>
        <p>
          We usually respond within 2–3 business days.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Subscriptions &amp; Purchases</p>
        <div class="separator-xs"></div>
        <p>
          If you have questions about a subscription, free trial, or in-app purchase
          (for example, if something did not unlock after purchase), please contact us at
          <a href="mailto:info@arcade-space.com">info@arcade-space.com</a> with a copy of
          your purchase receipt from Apple or your Apple ID email (do not send your password).
        </p>
        <p>
          Changes to subscriptions (cancelling or modifying a plan) are managed by Apple in
          <i>Settings &gt; Apple ID &gt; Subscriptions</i>. If you need help finding this,
          write to us and we will guide you.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Reporting a Bug or Problem</p>
        <div class="separator-xs"></div>
        <p>
          If the app crashes, behaves unexpectedly, or you notice something not working as
          described, please let us know. Include:
        </p>
        <ul>
          <li>What you were trying to do</li>
          <li>Steps to reproduce the issue</li>
          <li>Any error messages you saw</li>
        </ul>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Feedback &amp; Feature Requests</p>
        <div class="separator-xs"></div>
        <p>
          We welcome ideas for improvements and new features. You can send suggestions to
          <a href="mailto:info@arcade-space.com">info@arcade-space.com</a>.
          While we cannot guarantee every request will be implemented, we review all feedback.
        </p>

        <div class="separator-big"></div>
        <p class="sub-title-bold">Privacy &amp; Data</p>
        <div class="separator-xs"></div>
        <p>
          For questions about how we handle data in our apps, please review our Privacy Policy
          or contact us at <a href="mailto:info@arcade-space.com">info@arcade-space.com</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  text-align: left;
  padding: 10px 30px;
}
.title {
  font-family: "Roboto Condensed";
  font-size: 50px;
  margin: 0;
}

.sub-title {
  font-family: "Roboto Condensed";
  font-size: 40px;
  margin: 0;
}

.sub-title-bold {
  font-family: "Roboto Condensed";
  font-size: 25px;
  font-weight: bold;
  margin: 0;
}

.content {
  font-family: "Roboto Condensed";
  font-size: 22px;
  margin: 0;
}

.separator {
  &-big {
    height: 30px;
  }
  &-small {
    height: 18px;
  }
  &-xs {
    height: 13px;
  }
}

ul {
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 24px;
}
</style>
